import { useSelector } from 'react-redux';

import { selectIsDraftTermsUpdated } from '@lib/tools/locale/selectors/devtoolsLocale';
import { setIsDraftTermsUpdated } from '@lib/tools/locale/slice/devtoolsLocale';
import { useTypedDispatch } from '@lib/tools/views/hooks';

export const useDevtoolsLocale = () => {
  const dispatch = useTypedDispatch();

  const detectIsDraftTermsUpdated = (value: boolean) => {
    dispatch(setIsDraftTermsUpdated(value));
  };

  const isDraftTermsUpdated = useSelector(selectIsDraftTermsUpdated);

  return { detectIsDraftTermsUpdated, isDraftTermsUpdated };
};
